import React, { useEffect, useState } from "react";
import * as S from "./styles";

const HamburgerButton = ({
  onClick,
  initialOpen = false,
  ariaLabel = "Toggle navigation",
}) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  useEffect(() => {
    setIsOpen(initialOpen);
  }, [initialOpen]);

  const handleClick = () => {
    setIsOpen(!isOpen);
    if (onClick) {
      onClick(!isOpen);
    }
  };

  return (
    <S.StyledButton
      onClick={handleClick}
      aria-label={ariaLabel}
      aria-expanded={isOpen}
    >
      <S.Wrapper>
        <S.Line $position="top" $isOpen={isOpen} />
        <S.Line $position="middle" $isOpen={isOpen} />
        <S.Line $position="bottom" $isOpen={isOpen} />
      </S.Wrapper>
    </S.StyledButton>
  );
};

export default HamburgerButton;
